<template>
  <div class="nav-link">
    <div class="column has-not-bottom-padding" @click="navigate">
      <span class="has-cursor-pointer" :class="linkStyle">
        {{ text }}
      </span>
    </div>
    <div><hr class="margin-navbar-conf is-hidden-mobile" /></div>
  </div>
</template>

<script>
export default {
  name: 'NavbarLink',
  props: {
    text: String,
    active: {
      default: false,
      type: Boolean
    },
    target: String
  },
  computed: {
    linkStyle() {
      return {
        active: this.active
      }
    }
  },
  methods: {
    navigate() {
      // fullpage defines this global thingy. what a stupid thing to do on vue
      fullpage_api.moveTo(this.target) // eslint-disable-line no-undef
    }
  }
}
</script>

<style scoped>
.has-cursor-pointer {
  color: darkgrey;
}

.has-cursor-pointer:hover {
  color: #00a0c6;
}

.has-cursor-pointer.active {
  color: #f39e52;
  font-weight: bold;
}

.nav-link {
  height: 10vh;
  font-size: 1.3em;
}

.margin-navbar-conf {
  margin: -0.3rem;
  background-color: darkgrey;
}

.has-not-bottom-padding {
  padding-bottom: 0;
}
</style>
